module.exports = __webpack_public_path__ + "img/point-manage-active.83f3358c.svg";